module.exports = __webpack_public_path__ + "static/media/gc-plaka-good.720c48ea.png";